import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=7db35d16"
import script from "./NewsList.js?vue&type=script&lang=js&external"
export * from "./NewsList.js?vue&type=script&lang=js&external"
import style0 from "./NewsList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports